import * as React from 'react';
import SaleDetailView from '~/apps/pos/admin/containers/sales/SaleDetailView';
import { Overlay, SideModal, SideModalContent } from '~/common/layout/Modals';
import Head from '~/common/layout/Head';

type Props = {
  saleId: string,
  onReturn: any,
}

type State = {}

class SaleDetail extends React.Component<Props, State> {

  onClose = () => {
    this.props.onReturn();
  };

  render() {
    const {saleId } = this.props;

    return (
      <Overlay onClick={this.onClose}>
        <SideModal>
          <Head headTitle={'Sale details'} />
          <SideModalContent>
              <SaleDetailView
                saleId={saleId}
                onReturn={this.onClose}
              />
          </SideModalContent>
        </SideModal>
      </Overlay>
    );
  }
}

export default SaleDetail as any;
